<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ props }">
        <v-text-field
          :model-value="modelValue"
          :label="label"
          :hint="hint"
          :persistent-hint="!!hint"
          :variant="variant"
          :density="density"
          readonly
          v-bind="props"
          clearable
          @update:model-value="onInput"
        >
          <template #prepend-inner>
            <div
              v-if="modelValue"
              class="color-preview rounded"
              :style="{ backgroundColor: modelValue }"
            ></div>
          </template>
        </v-text-field>
      </template>
      <v-color-picker
        :model-value="modelValue"
        :mode="mode"
        :modes="modes"
        show-swatches
        @update:model-value="onInput"
      ></v-color-picker>
    </v-menu>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: String,
  label: { type: String, default: "Color" },
  hint: { type: String, default: "" },
  mode: { type: String, default: "hex" },
  modes: { type: Array, default: () => ["hex", "rgb"] },
  // Field styling; left to Vuetify's defaults when not given
  variant: { type: String, default: undefined },
  density: { type: String, default: undefined },
});

const emit = defineEmits(["update:modelValue"]);

function onInput(value) {
  emit("update:modelValue", value);
}
</script>

<style scoped>
.color-preview {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  margin-right: 8px;
}
</style>
